// src/components/header/v2/designTokens.ts

export const HEADER_V2_DESIGN_SYSTEM = {
  colors: {
    // Brand anchor backgrounds and borders
    primaryBg: "bg-[var(--brand-primary)]",            // Imperial Indigo
    primaryText: "text-[var(--brand-primary)]",
    accentBg: "bg-[var(--brand-accent)]",              // Primary Brand Action Accent
    accentText: "text-[var(--brand-accent)]",
    accentHover: "hover:text-[var(--brand-accent)]",    // Hover text accent transitions
    accentBgHover: "hover:bg-[var(--brand-accent-hover)]", // Darker accent for CTA hover states
    borderColor: "border-white/10",         // Light border for announcement/header lines
    neutralBorder: "border-[var(--brand-border)]",      // Standard subtle gray divider border
    
    // Core Layout Canvas colors
    whiteBg: "bg-white",
    lightGrayBg: "bg-[var(--brand-surface-light)]",     // Soft warm body/input backdrop
    secondaryText: "text-[var(--brand-text-muted)]",     // Muted Gray for clear readable text
    primaryDarkText: "text-[var(--brand-text-dark)]",   // Charcoal for headings and primary labels
    footerBg: "bg-[#F2F5F8]",               // Premium light footer background (#F2F5F8)
    footerBottomBg: "bg-[#E8EDF3]",         // Premium bottom copyright visual closer (#E8EDF3)
  },
  typography: {
    fontFamilySans: "font-sans",           // Inter UI Text font
    fontFamilyHeading: "font-primary",     // Lexend Heading font
    
    // Sizing Tokens mapped from globals.css variables
    size10: "text-10",                      // 10px (0.625rem)
    size12: "text-12",                      // 12px (0.75rem)
    size14: "text-14",                      // 14px (0.875rem)
    size16: "text-16",                      // 16px (1.00rem)
    size18: "text-18",                      // 18px (1.125rem)
    size20: "text-20",                      // 20px (1.25rem)
    size24: "text-24",                      // 24px (1.50rem)
  },
  spacing: {
    // 8px-based Grid Spacing Scale
    paddingYxs: "py-2",                     // 8px (xs)
    paddingYsm: "py-3",                     // 12px (sm)
    paddingYmd: "py-4",                     // 16px (md)
    gapXs: "gap-2",                         // 8px (xs)
    gapSm: "gap-3",                         // 12px (sm)
    gapMd: "gap-4",                         // 16px (md)
    containerPadding: "px-4 md:px-6 lg:px-8", // 16px, 24px, 32px layout scale
  },
  borderRadius: {
    btn: "rounded-lg",                      // 8px radius
    card: "rounded-xl",                     // 12px radius
    input: "rounded-md",                    // 6px radius
    searchBar: "rounded-full",              // 9999px pill radius
  },
  elevation: {
    card: "shadow-[0_8px_30px_rgba(0,0,0,0.04)]",
    cardHover: "hover:shadow-[0_10px_20px_rgba(0,0,0,0.05)]",
    dropdown: "shadow-[0_12px_32px_rgba(0,0,0,0.12)]",
    floating: "shadow-[0_-4px_12px_rgba(0,0,0,0.08)]",
  },
  zIndex: {
    header: "z-30",
    dropdown: "z-40",
    backdrop: "z-[998]",
    drawer: "z-[999]",
    modal: "z-[1000]",
    toast: "z-[1001]",
  },
  animations: {
    panelEnter: "transition-all duration-150 ease-out origin-top scale-98 opacity-0",
    panelActive: "scale-100 opacity-100",
    columnFade: "transition-opacity duration-200 ease-in-out",
  }
};
